<template>
  <div v-if="data">
    <div class="container">
      <div class="row">
        <div class="col-sm">
          <button type="button" class="btn btn-link btn-l" @click="$router.go(-1)">
            &#8592;
          </button>
        </div>
        <div class="col-sm" v-html="data.misc.stepXOfY"></div>
        <div class="col-sm">
          <!-- <button type="button" class="btn btn-link btn-r"
            :disabled="!isPhoneNumberValid" @click="$router.push('/entercode')">
            &#8594;
          </button> -->
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-4 card">
          <br /><br />
          <h4 class="text-primary" v-html="data.phoneNumber.phoneNumberHeader"></h4>
          <p v-html="data.phoneNumber.phoneNumberText"></p>
          <div class="phone-number-wrapper">
            <!-- <select class="form-control prefix-select" v-model="prefix" @keypress="test()">
              <option :value="''">{{ data.misc.prefix }}</option>
              <option v-for="c in codesList" :value="c.code" v-bind:key="c.country">
                &#127758; {{ c.country }}
              </option>
            </select> -->
            <v-select v-if="codesList" ref="codes"
              v-model="prefix" :placeholder="data.misc.prefix" :reduce="country => country.code"
              label="country" @input="focusOrBlurInput($event)" :options="codesList" class="fs-60">
              <span slot="no-options">{{ data.misc.noMatchingOptions }}</span>
            </v-select>
            <div class="clearfix"></div>
            <div class="input-group sm-3">
              <div class="input-group-prepend">
                <span class="input-group-text">{{ '+' + prefix || '+' }}</span>
              </div>
              <input
                inputmode="numeric"
                ref="phone"
                class="form-control phone-number-input"
                type="text"
                name="phoneNumber"
                v-model="phoneNumber"
                :maxlength="phoneLength"
                @input="enforceNumbers()"
              />
            </div>
          </div>
          <div class="clearfix"></div>
          <p v-html="data.phoneNumber.phoneNumberExplanation"></p>
          <div class="clearfix--min"></div>
          <button class="btn btn-primary btn-lg btn-block"
            @click="phoneEntered()" :disabled="!isPhoneNumberValid" v-html="data.misc.nextBtn"></button>
          <div class="clearfix--min"></div>
          <alert v-show="alert" v-html="data.error.errorHeader"></alert>
          <p v-html="data.phoneNumber.phoneNumberDisclaimer"></p>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm"></div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '../../src/components/Alert'
import { request } from '../plugins/datocms'
import codes from 'country-calling-code'
import $ from 'jquery'

export default {
  name: 'confirm',
  components: {
    Alert
  },
  data () {
    return {
      language: sessionStorage.getItem('language'),
      phoneLength: 12,
      prefix: '',
      phoneNumber: '',
      data: null,
      alert: false
    }
  },
  computed: {
    isPhoneNumberValid () {
      if (this.phoneNumber && this.prefix && (this.phoneNumber.length > 8)) {
        return true
      } else {
        return false
      }
    },
    codesList () {
      if (codes) {
        let c = []
        for (let i = 0; i < codes.length; i++) {
          c.push({
            country: codes[i].country,
            code: codes[i].countryCodes[0]
          })
        }
        return c
      }
    }
  },
  methods: {
    afterDOM () {
      setTimeout(() => { window.scrollTo(0, 0) })
      this.$nextTick(() => $('.vs__search').css('height', '40px'))
      this.$nextTick(() => $('.vs__clear').css('margin', '0 14px 4px 0'))
    },
    focusOrBlurInput (evt) {
      if (evt) {
        this.$nextTick(() => this.$refs.phone.focus())
      } else {
        this.$nextTick(() => document.activeElement.blur())
      }
    },
    enterKeyHandler (e) {
      if (e.key === 'Enter' && this.isPhoneNumberValid) {
        this.phoneEntered()
      }
    },
    phoneEntered () {
      if (this.phoneNumber.startsWith('0')) {
        this.phoneNumber = this.phoneNumber.substring(1)
      }
      sessionStorage.setItem('phoneNumber', '+' + this.prefix + this.phoneNumber)
      sessionStorage.setItem('phoneNumberConfirmed', true)
      this.$router.push('entercode')
    },
    enforceNumbers () {
      this.phoneNumber = this.phoneNumber.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
    }
  },
  created () {
    window.addEventListener('keydown', this.enterKeyHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.enterKeyHandler)
  },
  watch: {
    prefix (prfx) {
      if (!prfx) {
        this.prefix = ''
      }
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          phoneNumber(locale: ` + sessionStorage.getItem('language') + `) {
            phoneNumberDisclaimer
            phoneNumberExplanation
            phoneNumberHeader
            phoneNumberText
          }
          misc(locale: ` + sessionStorage.getItem('language') + `) {
            nextBtn
            stepXOfY
            prefix
            noMatchingOptions
          }
          error(locale: ` + sessionStorage.getItem('language') + `) {
            errorHeader
          }
        }
      `
    })
    if (this.data) {
      this.data.misc.stepXOfY = this.data.misc.stepXOfY.replace('x', '1').replace('y', '3')
    }
    this.afterDOM()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#alert {
  display: none;
}
.container {
  padding-bottom: 6vh;
}
.page-item {
  color: transparent !important;
}
.margin-top-75 {
  margin-top: 75px;
}
.margin-top-25 {
  margin-top: 25px;
}
.header-wrapper {
  display: flex;
}
.left-header {
  text-align: left;
}
.phone-number-wrapper {
  display: inline-block;
  position: relative;
  font-size: 26px;
  width: 100%;
}
.phone-number-input {
  font-size: inherit;
  border-radius: 4px;
  border: solid 1px #ccc;
  text-align: left;
}
.phone-number-input:disabled {
  border: 0;
  background: transparent;
}
.fs-60 {
  font-size: 60%;
}
button:disabled {
  opacity: 0.3;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .container {
    margin-top: 8vh;
    margin-bottom: -7.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ConfirmNumber.vue